export class FormElementHelper {
	static getInputErrors(formElement: FormElement) {
		let errors = new Array<string>()

		formElement.inputs.forEach((input) => {
			if (input.errorBucket.length > 0) {
				console.log(input)
				errors = errors.concat(input.errorBucket)
			}
		})

		return errors
	}

	static getInputErrorsWithElements(formElement: FormElement) {
		let errors = new Array<Object>()

		formElement.inputs.forEach((input) => {
			if (input.errorBucket.length > 0) errors = errors.concat({ element: input, errors: input.errorBucket })
		})

		return errors
	}
}
